import { lazy } from 'react';

const AddCollegeAppModal = lazy(() => import('./AddCollegeAppModal'));
const ApplicationListModal = lazy(() => import('./ApplicationListModal'));
const MarkAsCompleteModal = lazy(() => import('./MarkAsCompleteModal'));
const MultipleEnrollmentConfirmationModal = lazy(
  () => import('./MultipleEnrollmentConfirmationModal'),
);
const EditEnrollmentDecisionModal = lazy(
  () => import('./EditEnrollmentDecisionModal'),
);

export default {
  ADD_COLLEGE_APPLICATION: AddCollegeAppModal,
  APPLICATION_LIST_MODAL: ApplicationListModal,
  MARK_AS_COMPLETE_MODAL: MarkAsCompleteModal,
  MULTIPLE_ENROLLMENT_CONFIRMATION_MODAL: MultipleEnrollmentConfirmationModal,
  EDIT_ENROLLMENT_DECISION_MODAL: EditEnrollmentDecisionModal,
};
